<template>
  <div class="template-id" v-if="isTemplate && id === 'createTemplate'">
    <string
      placeholder="Template ID"
      label="Template ID"
      :value="value"
      @setConfigValue="setConfigValue"
      :rules="clientIdRegex"
      tooltip="Alphanumeric characters only."
    />
  </div>
</template>
    
<script>
/**
 * @fileoverview Custom input field for template ID
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import { mapGetters } from "vuex";
import string from "@/components/config-field/string";

export default {
  name: "TemplateIdField",
  components: { string },
  props: {
    category: {
      type: String,
    },
    id: {
      type: String,
    },
    value: {
      type: String,
      default: "",
    },
    isTemplate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    clientIdRegex() {
      return [
        { Type: "required" },
        { Type: "unique", ExistingValues: this.existingIds },
        { Type: "regex", Value: "^[a-zA-Z][a-zA-Z0-9]*$" },
      ];
    },
    ...mapGetters({
      existingIds: "getExistingIds",
    }),
  },
  methods: {
    /**
     * Sets the value
     */
    setConfigValue(value) {
      this.$store.dispatch("setConfigValue", {
        ClientInfoRuleId: this.id,
        category: this.category,
        fieldId: "ClientId",
        value: value.trim(),
      });
    },
  },
};
</script>
    
  <style lang="scss" scoped>
.template-id {
  margin-bottom: 24px;
}
</style>